import api from "@/services";

/**
 * Mixin para busca de alunos com paginação e busca remota
 * 
 * Fornece:
 * - Lista de alunos com busca remota
 * - Estado de loading
 * - Preservação do aluno selecionado
 * - Método para obter turmas do aluno
 * 
 * Uso:
 * import studentSearchMixin from "@/mixins/studentSearchMixin";
 * 
 * export default {
 *   mixins: [studentSearchMixin],
 *   // ... resto do componente
 * }
 */
export default {
  data() {
    return {
      students: [],
      selectedStudent: null,
      loadingStudents: false,
      studentsCurrentPage: 0,
      studentsPerPage: 20,
    };
  },

  methods: {
    /**
     * Busca alunos com suporte a paginação e filtro por nome
     * @param {string} query - Termo de busca (opcional)
     */
    async searchStudents(query = '') {
      try {
        this.loadingStudents = true;
        
        const params = {
          page: this.studentsCurrentPage,
          perPage: this.studentsPerPage,
          sortBy: 'name',
        };

        // Adiciona o parâmetro de busca se houver query
        if (query && query.trim() !== '') {
          params.search = query.trim();
        }

        const queryString = Object.keys(params)
          .map(key => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');

        const response = await api.get(`/students?${queryString}`);
        let studentsData = response.data.data;
        
        // Garante que o aluno selecionado esteja sempre na lista
        if (this.selectedStudent) {
          const selectedExists = studentsData.some(
            student => student.id === this.selectedStudent.id
          );
          
          if (!selectedExists) {
            // Adiciona o aluno selecionado no início da lista
            studentsData = [this.selectedStudent, ...studentsData];
          }
        }
        
        this.students = studentsData;
      } catch (error) {
        console.error('Erro ao buscar alunos:', error);
        Toast.fire('Erro', 'Erro ao buscar alunos', 'error');
        this.students = [];
      } finally {
        this.loadingStudents = false;
      }
    },

    /**
     * Método legado mantido para compatibilidade
     * Usa searchStudents internamente
     */
    async getStudents() {
      await this.searchStudents('');
    },

    /**
     * Salva o aluno selecionado para manter referência
     * @param {number} studentId - ID do aluno selecionado
     */
    saveSelectedStudent(studentId) {
      const studentFiltered = this.students.filter(
        (student) => student.id == studentId
      );

      if (studentFiltered[0]) {
        this.selectedStudent = studentFiltered[0];
      }
    },

    /**
     * Limpa a seleção de aluno e recarrega a lista
     */
    clearStudentSelection() {
      this.selectedStudent = null;
      this.searchStudents('');
    },
  },
};
